import { useState } from 'react'
import ProfileDetails from './ProfileDetails';
import ProfileSetting from './ProfileSetting';
import Sidebar from './Sidebar';
// import './profile.css'
const Main = () => {
    const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };
    return (
        <div className="border border-orange-500   bg-white lg:w-[60vw] h-[55vh] w-[85vw] lg:h-[95vh] rounded-2xl">
            <div className='flex flex-row h-20  ml-0 w-[85vw] lg:w-[60vw] bg-white rounded-2xl border pl-8'>
                <button
            className={toggleState === 1 ? "text-xl text-orange-500 border-b-2 border-orange-500" : "text-xl text-slate-500"}
            onClick={() => toggleTab(1)}>
                Profile</button>
                <button 
                className={toggleState === 2 ? "text-xl text-orange-500 ml-12 border-b-2 border-orange-500" : "text-xl text-slate-500 pl-12"}
                onClick={() => toggleTab(2)}
                >Settings</button>
            </div>
            <div>
                <div className={toggleState === 1 ? "" : "hidden"}>
                        <div
                        className='flex justify-center items-center'
                        >
                        <ProfileDetails />
                        </div>
                </div>
                <div className={toggleState === 2 ? "" : "hidden"}>
                    <div >
                    <ProfileSetting />
                </div>
                </div>
                
                
                
            </div>
        </div>
    )
}
export default Main